import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface DynamicCardField {
  label: string;
  value: string;
}

@Component({
  selector: "route-sheet-dynamic-card",
  templateUrl: "./dynamic-card.component.html",
  styleUrls: ["./dynamic-card.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteSheetDynamicCardComponent {
  @Input() title: string = "";
  @Input() key: string = "";
  @Input() subtitle: string = "";
  @Input() status: string = "";
  @Input() fields: DynamicCardField[] = [];
  @Input() skeletonLoading: boolean = false;

}
